<div class="content-with-side-menu">
    <div class="row no-gutters">
        <div class="col-md-auto">
            <app-coupons-search-criteria
                hznTestId="coupons-list-filters"
                [filters]="filters"
                [searchForm]="searchForm"
            ></app-coupons-search-criteria>
        </div>

        <div class="col">
            <div
                class="row no-gutters top-panel height-60 line-height-40 padding-10"
            >
                <div
                    class="col-auto"
                    bcShowIfPrivilegeDynamic="Camps.canViewReports"
                >
                    <button
                        class="btn btn-success export-to-xls"
                        hznTestId="coupons-list-export"
                        bcClick
                        (clicked)="exportToXls()"
                    >
                        {{ "CouponsList.ExportToXls" | translate }}
                    </button>
                </div>
                <div class="col legal-verbiage">
                    <span
                        class="title"
                        [tooltip]="LegalVerbiagetooltip"
                        placement="bottom"
                        containerClass="legal-tooltip"
                    >
                        <i class="i-questionmark"></i>
                        {{
                            "CouponDetails.LegalVerbiageTitle" | translate
                        }}</span
                    >

                    <ng-template #LegalVerbiagetooltip>
                        <p>
                            {{ "CouponDetails.LegalVerbiagePart2" | translate }}
                        </p>
                        <p>
                            {{ "CouponDetails.LegalVerbiagePart3" | translate }}
                        </p>
                    </ng-template>
                </div>
                <div class="col">
                    <div
                        bcShowIfPrivilegeDynamic="Camps.campsCanManageCoupons"
                        class="btn btn-success float-right size-14"
                        hznTestId="coupons-list-create"
                        (click)="createCoupon()"
                    >
                        {{ "CouponsList.CreateBtn" | translate }}
                    </div>
                </div>
            </div>

            <div>
                <bcu-local-spinner
                    [size]="50"
                    [visible]="isBusy"
                ></bcu-local-spinner>

                <div
                    class="list-group list-group-flush grid"
                    infinite-scroll
                    [infiniteScrollDistance]="0.1"
                    [infiniteScrollThrottle]="300"
                    [infiniteScrollDisabled]="isBusy"
                    (scrolled)="onScroll()"
                >
                    <div
                        class="list-group-item list-group-item-action flex-column align-items-start grid-header"
                    >
                        <div class="row">
                            <div class="col-md-1 col-sm-1 grid-column">
                                {{ "CouponsList.CodeHeader" | translate }}
                            </div>
                            <div class="col-md-1 col-sm-1 grid-column">
                                {{ "CouponsList.TypeHeader" | translate }}
                            </div>
                            <div class="col-md-1 col-sm-1 grid-column">
                                {{ "CouponsList.ValueHeader" | translate }}
                            </div>
                            <div class="col-md-1 col-sm-1 grid-column">
                                {{ "CouponsList.UsageTypeHeader" | translate }}
                            </div>
                            <div class="col-md-2 col-sm-1 grid-column">
                                {{ "CouponsList.StatusHeader" | translate }}
                            </div>
                            <div class="col-md-1 col-sm-1 grid-column">
                                {{ "CouponsList.CategoryHeader" | translate }}
                            </div>
                            <div class="col-md-2 col-sm-1 grid-column">
                                {{ "CouponsList.SentToHeader" | translate }}
                            </div>
                            <div class="col-md-1 col-sm-1 grid-column">
                                {{ "CouponsList.CreatedHeader" | translate }}
                            </div>
                            <div class="col-md-1 col-sm-1 grid-column">
                                {{ "CouponsList.ValidHeader" | translate }}
                            </div>
                            <div class="col-md-1 col-sm-1 grid-column">
                                {{ "CouponsList.ActionsHeader" | translate }}
                            </div>
                        </div>
                    </div>

                    @for (item of items; track item) {
                        <div
                            class="list-group-item list-group-item-action flex-column align-items-start clickable"
                            (click)="onViewDetails(item)"
                        >
                            <app-coupon-list-row hznTestId="coupons-list-row" [item]="item">
                            </app-coupon-list-row>
                        </div>
                    }
                    @if (noItems && !isBusy) {
                        <div class="no-items-info padding-20" hznTestId="coupons-list-no-items">
                            <span>{{ "CouponsList.NoItems" | translate }}</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
